import {FC, useContext} from 'react';
//formik
import {Field, useFormikContext} from 'formik';
//mui
import {Box} from '@mui/material';
//icons
import {ReactComponent as ArrowIcon} from '@/assets/icons/arrow-line-left.svg';
//constants
import {FIELD, NEXT} from '@/utils/constants';
//context
import {OrganizationSignUpContext} from '@/pages/Organization/OrganizationSignUp/OrganizationSignUpContext';
//components
import UploadAvatar from '@/shared/components/UploadDropzone/UploadAvatar';
import StepperHeader from '../../../HeaderForm';
import StepperActions from '../StepperActions';
//form configuration
import {SignUpFormValues} from '../formConfiguration';
//styles
import {logoFormContentStyle} from './LogoFormContent.styles';

const LogoFormContent: FC = () => {
  const {
    values: {image},
    submitForm,
  } = useFormikContext<SignUpFormValues>();

  const {activeStep, nextStepHandler} = useContext(OrganizationSignUpContext);

  const onStepClickHandler = () => {
    nextStepHandler(activeStep + 1);
  };
  return (
    <Box sx={logoFormContentStyle.wrapper}>
      <StepperHeader
        title="Organization Logo"
        description="Organization logo will be used to brand event website, auction website, and emails."
      />
      <Box sx={logoFormContentStyle.avatar}>
        <Field id={FIELD.image} name={FIELD.image} component={UploadAvatar} />
      </Box>

      <StepperActions
        title={NEXT}
        nextClickHandler={submitForm}
        skipClickHandler={onStepClickHandler}
        nextDisabled={!image}
        icon={<ArrowIcon />}
      />
    </Box>
  );
};

export default LogoFormContent;
